import { gql } from "@apollo/client";

export const CreateInstalledBaseNotificationSetting = gql`
    mutation CreateInstalledBaseNotificationSetting ($notificationType: InstalledBaseNotificationType!) {
        createInstalledBaseNotificationSetting(notificationType: $notificationType) {
            __typename
            id
            active
            inApp
            mail
            push
        }
    }
`;
